import * as React from "react";
import { Avatar, ButtonBase, Skeleton, Stack, Typography } from "@mui/material";
import { useOpenSite, SITE_SELECTION_SOURCE } from "../../../../../../../scripts/amplitude_utils";
import { ElindusRedColors, shortenUsername, timeAgo } from "../../../../../../../scripts/utils";
import { CollapsableCard } from "../../../../../../../components/general/collapsable_card";

function ReviewTimelineCard({ changelog, title = "Review Timeline", tooltip = null, rightAdornment = null, ...props }) {
  const count = Array.isArray(changelog) ? changelog.length : 0;

  return (
    <CollapsableCard
      title={title + ` (${count})`}
      tooltip={tooltip}
      rightAdornment={rightAdornment}
      {...props}
      sx={{
        display: "flex",
        flexDirection: "column",
        ...props.sx,
      }}
    >
      <Stack spacing={1}>
        {[...Array(count)].map((_, index) =>
          changelog && index < changelog.length ? (
            <ChangeItem
              key={changelog[index].site_name + changelog[index].description + changelog[index].datetime}
              userName={changelog[index].modified_by_user}
              siteName={changelog[index].site_name}
              siteId={changelog[index].site_id}
              description={changelog[index].description}
              timestamp={changelog[index].datetime}
              isLoading={false}
            />
          ) : null,
        )}
      </Stack>
    </CollapsableCard>
  );
}

export default ReviewTimelineCard;

const AVATAR_SIZE = 40;

function ChangeItem({ userName, siteId, siteName, timestamp, description, isLoading, isHidden = false }) {
  const openSite = useOpenSite();

  return !isHidden ? (
    <>
      <ButtonBase
        onClick={() => openSite(siteId, SITE_SELECTION_SOURCE.REVIEW_TIMELINE)}
        sx={{
          width: "100%",
          alignItems: "center",
          display: "flex",
          textAlign: "left",
          borderRadius: "10px",
          padding: 1,
          "&:hover": { backgroundColor: "#f3f3f3" },
        }}
        disabled={true}
      >
        {isLoading ? (
          <Skeleton variant="circular" width={AVATAR_SIZE} height={AVATAR_SIZE} />
        ) : (
          <Avatar sx={{ bgcolor: ElindusRedColors(userName) }}>{shortenUsername(userName)}</Avatar>
        )}

        <Stack sx={{ flexGrow: 1, marginLeft: 2 }}>
          <Typography variant="body2">{isLoading ? <Skeleton /> : siteName}</Typography>
          <Typography variant="caption">{isLoading ? <Skeleton /> : description}</Typography>
          <Typography variant="caption" color={"#aaa"} sx={{ textAlign: "left" }}>
            {isLoading ? <Skeleton width="100px" /> : timeAgo(new Date(1000 * timestamp))}
          </Typography>
        </Stack>
      </ButtonBase>
    </>
  ) : null;
}
